import { createBrowserRouter, RouterProvider } from "react-router-dom";

import BackLayoutMain from "../components/backLayout/main"; // 後台 - 介面外框
import BackLogin from "../page/back/login"; // 登入頁
import BackHome from "../page/back/home"; // 後臺首頁
import BackProjectList from "../page/back/project";
import BackProjectDetail from "../page/back/project/detail";

import FrontIframeSingleChart from "../page/iframe/single";
import FrontIframeMultiChart from "../page/iframe/multi";

export default function CreatRoute() {
  const router = createBrowserRouter([
    {
      path: "",
      element: <BackLogin />,
    },
    {
      path: "/login",
      element: <BackLogin />,
    },
    {
      path: "/back",
      element: <BackLayoutMain model="back" />,
      children: [
        {
          path: "",
          element: <BackHome />,
        },
        {
          path: "home",
          element: <BackHome />,
        },
        {
          path: "project",
          element: <BackProjectList />,
        },
        {
          path: "project/:detailid",
          element: <BackProjectDetail />,
        },
        {
          path: "*",
          element: <>無畫面</>,
        },
      ],
    },
    {
      path: "/iframe/multi/:detailid",
      element: <FrontIframeMultiChart />,
    },
    {
      path: "/iframe/single/:systemWeb/:diagram",
      element: <FrontIframeSingleChart />,
    },
    {
      path: "*",
      element: <>無畫面</>,
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}
